class BrickRecommendations {
    suggestedStrategy;
    alignmentResults;
    properties;
    constructor(data) {
        this.suggestedStrategy = data.suggestedStrategy;
        this.alignmentResults = data.alignmentResults;
        this.properties = data.properties;
    }
}
export default BrickRecommendations;
